import { ADD_PROJECT, ADD_PROJECT_CATEGORY, ADD_PROJECT_CATEGORY_FAILED, ADD_PROJECT_CATEGORY_SUCCESS, ADD_PROJECT_FAILED, ADD_PROJECT_FILES, ADD_PROJECT_FILES_FAILED, ADD_PROJECT_FILES_SUCCESS, ADD_PROJECT_LABEL, ADD_PROJECT_LABEL_FAILED, ADD_PROJECT_LABEL_SUCCESS, ADD_PROJECT_MILESTONES, ADD_PROJECT_MILESTONES_FAILED, ADD_PROJECT_MILESTONES_SUCCESS, ADD_PROJECT_SUCCESS, CLEAR_ADD_PROJECT_MILESTONES, DELETE_PROJECT_CATEGORY, DELETE_PROJECT_CATEGORY_FAILED, DELETE_PROJECT_CATEGORY_SUCCESS, DELETE_PROJECT_LABEL, DELETE_PROJECT_LABEL_FAILED, DELETE_PROJECT_LABEL_SUCCESS, DELETE_PROJECT_MILESTONES, DELETE_PROJECT_MILESTONES_FAILED, DELETE_PROJECT_MILESTONES_SUCCESS, FILTERED_PROJECT, FILTERED_PROJECT_FAILED, FILTERED_PROJECT_SUCCESS, PROJECT, PROJECT_CATEGORY, PROJECT_CATEGORY_FAILED, PROJECT_CATEGORY_SUCCESS, PROJECT_FAILED, PROJECT_FILES, PROJECT_FILES_FAILED, PROJECT_FILES_SUCCESS, PROJECT_LABEL, PROJECT_LABEL_FAILED, PROJECT_LABEL_SUCCESS, PROJECT_MILESTONES, PROJECT_MILESTONES_FAILED, PROJECT_MILESTONES_SUCCESS, PROJECT_SUCCESS, UPDATE_PROJECT, UPDATE_PROJECT_FAILED, UPDATE_PROJECT_MILESTONES, UPDATE_PROJECT_MILESTONES_FAILED, UPDATE_PROJECT_MILESTONES_SUCCESS, UPDATE_PROJECT_SUCCESS } from "./actionTypes"

let initialState = {
    project: [],
    projectFiles: [],
    projectMilestones: [],
    addProjectMilestones: "",
    updateProjectMilestones: "",
    deleteProjectMilestones: "",
    addProjectFile: "",
    addProject: "",
    updateProject: "",
    deleteProject: "",
    loading: false,
    deleteLoading: false,
    success: false,
    error: ''
}

export const projectReducer = (state = initialState, action) => {
    switch (action.type) {

        case PROJECT: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case PROJECT_SUCCESS: return {
            ...state,
            project: action.payload,
            loading: false,
            success: true
        }
        case PROJECT_FAILED: return {
            ...state,
            loading: false,
            success: false,
            error: action.payload
        }
        case ADD_PROJECT: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case ADD_PROJECT_SUCCESS: return {
            ...state,
            addProject: action.payload,
            project: state.project.some(p => p.id === action.payload.id)
                ? state.project
                : [...state.project, action.payload],
            loading: false,
            success: true,
            error: ''
        }
        case ADD_PROJECT_FAILED: return {
            ...state,
            addProject: [],
            loading: false,
            success: false,
            error: action.payload
        }
        case UPDATE_PROJECT: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case UPDATE_PROJECT_SUCCESS: return {
            ...state,
            updateProject: action.payload,
            project: Array.isArray(state.project)
                ? state.project.map((item) =>
                    item?.id === action.payload.id
                        ? { ...item, ...action.payload }
                        : item
                )
                : [],
            loading: false,
            success: true,
            error: ''
        }
        case UPDATE_PROJECT_FAILED: return {
            ...state,
            updateProject: [],
            loading: false,
            success: false,
            error: action.payload
        }
        case PROJECT_FILES: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case PROJECT_FILES_SUCCESS: return {
            ...state,
            projectFiles: action.payload,
            loading: false,
            success: true
        }
        case PROJECT_FILES_FAILED: return {
            ...state,
            loading: false,
            success: false,
            error: action.payload
        }
        case ADD_PROJECT_FILES: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case ADD_PROJECT_FILES_SUCCESS: return {
            ...state,
            addProjectFile: action.payload,
            projectFiles: [...state.projectFiles, action.payload],
            loading: false,
            success: true,
            error: ''
        }
        case ADD_PROJECT_FILES_FAILED: return {
            ...state,
            addProjectFile: "",
            projectFiles: [],
            loading: false,
            success: false,
            error: action.payload
        }
        case PROJECT_MILESTONES: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case PROJECT_MILESTONES_SUCCESS: return {
            ...state,
            projectMilestones: action.payload,
            loading: false,
            success: true
        }
        case PROJECT_MILESTONES_FAILED: return {
            ...state,
            loading: false,
            success: false,
            error: action.payload
        }
        case ADD_PROJECT_MILESTONES: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case ADD_PROJECT_MILESTONES_SUCCESS: return {
            ...state,
            addProjectMilestones: action.payload,
            projectMilestones: [...state.projectMilestones, action.payload],
            loading: false,
            success: true,
            error: ''
        }
        case ADD_PROJECT_MILESTONES_FAILED: return {
            ...state,
            addProjectMilestones: [],
            loading: false,
            success: false,
            error: action.payload
        }
        case CLEAR_ADD_PROJECT_MILESTONES:
            return {
                ...state,
                addProjectMilestones: null,
            };
        case UPDATE_PROJECT_MILESTONES: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case UPDATE_PROJECT_MILESTONES_SUCCESS: return {
            ...state,
            updateProjectMilestones: action.payload,
            loading: false,
            success: true,
            error: ''
        }
        case UPDATE_PROJECT_MILESTONES_FAILED: return {
            ...state,
            updateProjectMilestones: [],
            loading: false,
            success: false,
            error: action.payload
        }
        case DELETE_PROJECT_MILESTONES: return {
            ...state,
            deleteLoading: true,
            success: false,
            error: ''
        }
        case DELETE_PROJECT_MILESTONES_SUCCESS: return {
            ...state,
            deleteProjectMilestones: action.payload,
            projectMilestones: action.payload,
            deleteLoading: false,
            success: true
        }
        case DELETE_PROJECT_MILESTONES_FAILED: return {
            ...state,
            deleteLoading: false,
            success: false,
            error: action.payload
        }


        default: return state
    }
}